import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

const DEFAULT_NOTIFICATION_DURATION = 10 * 1000; // 10 seconds

// Async thunk to handle auto-dismiss notifications
export const pushNotificationWithTimeout = createAsyncThunk(
  'notifications/pushNotificationWithTimeout',
  async (notificationData, { dispatch, getState }) => {
    const state = getState().notifications;
    const now = Date.now();
    const deduplicationWindow = 2000; // 2 seconds

    const messageKey = notificationData.message || notificationData.title;

    const lastShownAt = state.recentNotifications[messageKey];
    if (lastShownAt && now - lastShownAt < deduplicationWindow) {
      return; // Don't show duplicate notification within the window
    }

    const duration = notificationData.permanent
      ? null
      : notificationData.duration ?? DEFAULT_NOTIFICATION_DURATION;

    const notification = {
      ...notificationData,
      id: uuid(),
      sentAt: now,
      duration,
    };

    dispatch(pushNotification(notification)); // Add notification

    if (duration) {
      setTimeout(() => {
        dispatch(closeNotification(notification.id)); // Remove after duration
      }, duration);
    }

    dispatch(markNotificationAsRecent({ key: messageKey, timestamp: now }));
  }
);

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    closedNotifications: [],
    recentNotifications: {}, // key: message, value: timestamp
  },
  reducers: {
    pushNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    closeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notif => notif.id !== action.payload
      );
      state.closedNotifications.push(action.payload);
    },
    markNotificationAsRecent: (state, action) => {
      const { key, timestamp } = action.payload;
      state.recentNotifications[key] = timestamp;
    },
  },
});

export const { pushNotification, closeNotification, markNotificationAsRecent } =
  notificationsSlice.actions;
export default notificationsSlice.reducer;
